"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { useEffect, useState } from "react";
import { CartLink } from "./AddToCartButton";

const LINKS = [
  { href: "/", label: "Home" },
  { href: "/about", label: "About Us" },
  { href: "/services", label: "Services" },
  { href: "/pricing", label: "Pricing" },
  { href: "/blogs", label: "Blogs" },
  { href: "/contact", label: "Contact Us" },
];

function isDark(): boolean {
  const a = document.documentElement.getAttribute("data-theme");
  if (a) return a === "dark";
  return window.matchMedia("(prefers-color-scheme: dark)").matches;
}

export function SiteNav() {
  const pathname = usePathname();
  const [open, setOpen] = useState(false);
  const [dark, setDark] = useState(false);

  useEffect(() => {
    try {
      const saved = localStorage.getItem("jdweb.theme");
      if (saved) document.documentElement.setAttribute("data-theme", saved);
    } catch {
      /* ignore */
    }
    setDark(isDark());
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  useEffect(() => {
    function closeMenu() {
      setOpen(false);
    }
    window.addEventListener("jd:nav-close", closeMenu);
    return () => window.removeEventListener("jd:nav-close", closeMenu);
  }, []);

  function toggleTheme() {
    const next = isDark() ? "light" : "dark";
    document.documentElement.setAttribute("data-theme", next);
    try {
      localStorage.setItem("jdweb.theme", next);
    } catch {
      /* ignore */
    }
    setDark(next === "dark");
  }

  return (
    <header className={"site-nav" + (open ? " is-open" : "")}>
      <Link href="/" className="nav-brand brand" onClick={() => setOpen(false)}>
        <span className="crest-hub brand-hub">
          <span className="hub-ring" />
          <span className="hub-ring hub-ring-2" />
          <img
            src="/logo-32.webp"
            alt=""
            width={32}
            height={32}
            decoding="async"
          />
        </span>
        <span>JD INTEGRATIONS</span>
      </Link>
      <nav className="nav-links" aria-label="Primary">
        {LINKS.map((l) => (
          <Link
            key={l.href}
            href={l.href}
            className={pathname === l.href ? "is-active" : undefined}
            onClick={() => setOpen(false)}
          >
            {l.label}
          </Link>
        ))}
      </nav>
      <div className="nav-cta">
        <CartLink />
        <button className="theme-btn" type="button" aria-label="Toggle theme" onClick={toggleTheme}>
          {dark ? "☀" : "☾"}
        </button>
        <Link href="/contact?intent=quote" className="btn btn-primary" onClick={() => setOpen(false)}>
          Get a quote
        </Link>
      </div>
      <button
        className="nav-toggle icon-round"
        type="button"
        aria-label="Menu"
        aria-expanded={open}
        onClick={() => setOpen((v) => !v)}
      >
        ☰
      </button>
    </header>
  );
}
